import localStorageService from 'js-promo-partners-lib/lib/services/local-storage-service/local-storage-service';
import PluginHttpClient from './plugin-http-client';

export default new PluginHttpClient({
    ignoreTLSErrors: false,
    storageProvider: localStorageService,
});
